import React from 'react';
import { IconPropsType } from '..';

export const Bnb: React.FC<IconPropsType> = ({ width = 24, height = 24, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 283.46 283.46"
      fill="none"
      {...props}
    >
      <circle
        fill="#f0b90b"
        cx="141.73"
        cy="141.73"
        r="135.72"
      />
      <g>
        <path
          fill="#fff"
          d="M107.72,127.37l34.03-34.01,34.04,34.04,19.79-19.8-53.83-53.84-53.83,53.83,19.8,19.79Z"
        />
        <path
          fill="#fff"
          d="M54.14,141.36l19.79-19.79,19.79,19.79-19.79,19.79-19.79-19.79Z"
        />
        <path
          fill="#fff"
          d="M107.72,155.34l34.03,34.03,34.04-34.04,19.8,19.77h-.01s-53.83,53.86-53.83,53.86l-53.83-53.81-.03-.03,19.83-19.77Z"
        />
        <path
          fill="#fff"
          d="M189.74,141.36l19.79-19.79,19.79,19.79-19.79,19.79-19.79-19.79Z"
        />
        <path
          fill="#fff"
          d="M161.83,141.35l-20.08-20.09-14.85,14.85-1.72,1.7-3.51,3.51-.03.03.03.04,20.08,20.06,20.08-20.09Z"
        />
      </g>
    </svg>
  );
};
